/**
 * 데이터 분석 API (docs/features/30-data-analysis.md) — 분석 정의 저장·불러오기와 분석 대상 카탈로그(스키마·테이블·컬럼과 주석).
 * 분석 SQL 은 화면이 만들고(utils/analysisQueryBuilder) 실행은 편집기에서 한다 — 여기에 실행 API 는 없다.
 */
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/sql-developer';
const ROOT = `${BASE_URL}/data-analysis`;
const enc = encodeURIComponent;

export async function lookupCatalog({ connectionId, schema, q }) { return (await axios.post(`${ROOT}/catalog`, { connectionId, schema, q })).data; }
export async function describeTable({ connectionId, table }) { return (await axios.post(`${ROOT}/columns`, { connectionId, table })).data.table; }

export async function listDefs() { return (await axios.get(`${ROOT}/defs`)).data.defs || []; }
export async function getDef(id) { return (await axios.get(`${ROOT}/defs/${enc(id)}`)).data.def; }
export async function createDef({ name, spec }) { return (await axios.post(`${ROOT}/defs`, { name, spec })).data.def; }
export async function updateDef(id, { name, spec }) { return (await axios.put(`${ROOT}/defs/${enc(id)}`, { name, spec })).data.def; }
export async function deleteDef(id) { return (await axios.delete(`${ROOT}/defs/${enc(id)}`)).data; }
